/* One fixed offer deadline, shared by all campaign placements. */
(() => {
  const hasZone = (value) => typeof value === 'string' && /T.*(?:Z|[+-]\d{2}:\d{2})$/.test(value);
  function saleState({ enabled, preview, end }, now = Date.now()) {
    if (preview === true || preview === 'true') return 'preview';
    if (enabled !== true && enabled !== 'true') return 'inactive';
    if (!hasZone(end)) return 'inactive';
    const endTime = Date.parse(end);
    return Number.isFinite(endTime) && now < endTime ? 'active' : 'inactive';
  }
  function countdownParts(end, now = Date.now()) {
    const remaining = Date.parse(end) - now;
    if (!Number.isFinite(remaining) || remaining <= 0) return null;
    const seconds = Math.ceil(remaining / 1000);
    return {
      days: Math.floor(seconds / 86400),
      hours: Math.floor((seconds % 86400) / 3600),
      minutes: Math.floor((seconds % 3600) / 60),
      seconds: seconds % 60
    };
  }
  function timeRemaining(end, now = Date.now()) {
    const parts = countdownParts(end, now);
    return parts ? `Ends in ${Object.entries(parts).map(([unit, value]) => `${value} ${value === 1 ? unit.slice(0, -1) : unit}`).join(', ')}` : '';
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { saleState, timeRemaining, countdownParts };
  if (typeof window === 'undefined' || customElements.get('fresh-clay-sale')) return;

  const instances = new Set();
  let interval;
  const stopClock = () => {
    if (interval !== undefined) window.clearInterval(interval);
    interval = undefined;
  };
  const updateAll = () => {
    const now = Date.now();
    instances.forEach((instance) => instance.update(now));
    if (![...instances].some((instance) => instance.dataset.phase === 'active')) stopClock();
  };
  const startClock = () => {
    if (document.hidden || !instances.size) return;
    updateAll();
    if (interval === undefined && [...instances].some((instance) => instance.dataset.phase === 'active')) {
      interval = window.setInterval(updateAll, 1000);
    }
  };
  document.addEventListener('visibilitychange', () => {
    stopClock();
    if (!document.hidden) startClock();
  });
  document.addEventListener('DOMContentLoaded', startClock, { once: true });

  class FreshClaySale extends HTMLElement {
    connectedCallback() {
      instances.add(this);
      this.update();
      startClock();
    }
    disconnectedCallback() {
      instances.delete(this);
      if (!instances.size) stopClock();
    }
    update(now = Date.now()) {
      const state = saleState(this.dataset, now);
      if (this.dataset.phase !== state) this.dataset.phase = state;
      this.hidden = state === 'inactive' || this.dataset.selected === 'false';
      const fallback = this.closest('[data-clay-sale-surface]')?.querySelector('[data-clay-sale-fallback]');
      if (fallback) fallback.hidden = state !== 'inactive';
      // Parser-created elements may connect before their child clock exists.
      this.timer ||= this.querySelector('[data-sale-timer]');
      if (this.timer) {
        const parts = state === 'active' ? countdownParts(this.dataset.end, now) : null;
        this.timer.hidden = !parts;
        if (parts) {
          this.numbers ||= Object.fromEntries(Object.keys(parts).map((unit) => [unit, this.timer.querySelector(`[data-sale-${unit}]`)]));
          this.timer.setAttribute('aria-label', timeRemaining(this.dataset.end, now));
          for (const [unit, value] of Object.entries(parts)) {
            const number = this.numbers[unit];
            const text = String(value).padStart(2, '0');
            if (number && number.textContent !== text) number.textContent = text;
          }
        }
      }
      this.preview ||= this.querySelector('[data-sale-preview]');
      if (this.preview) this.preview.hidden = state !== 'preview';
    }
  }
  customElements.define('fresh-clay-sale', FreshClaySale);
})();
